module.exports = __webpack_public_path__ + "img/step.adb2b542.png";